import { render, staticRenderFns } from "./Quedan.vue?vue&type=template&id=471840a4&scoped=true&"
import script from "./Quedan.vue?vue&type=script&lang=js&"
export * from "./Quedan.vue?vue&type=script&lang=js&"
import style0 from "./Quedan.vue?vue&type=style&index=0&id=471840a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471840a4",
  null
  
)

export default component.exports